import { useAuthContext } from 'contexts/AuthContext';
import { Navigate } from 'react-router-dom';

function AppGuard(props: any) {
  const { children } = props;

  const { auth } = useAuthContext();
  if (!auth?.token) {
    return <Navigate to="/connexion" replace />;
  }

  return children;
}

export default AppGuard;
